import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUnlock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 14v3M7.75 9.75V7a4.25 4.25 0 0 1 8.435-.746M6.75 21.25h10.5a2 2 0 0 0 2-2v-7.5a2 2 0 0 0-2-2H6.75a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUnlock);
export default ForwardRef;
